document.querySelectorAll('.c-faq__q').forEach(button => {
  button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    const content = button.closest('.c-faq__item').querySelector('.c-faq__a');
    content.inert = expanded;
    content.setAttribute('aria-hidden', String(expanded));
  });
});
